module.exports = __webpack_public_path__ + "img/io.8daa0f5a.svg";